import type { FileUploadConfig } from '../types/attachments';

/**
 * Default file upload configuration when the consumer enables file upload
 * without passing a full config. Override any key via actionBarConfig.fileUploadConfig.
 */
export const DEFAULT_FILE_UPLOAD_CONFIG: Required<
  Pick<FileUploadConfig, 'maxFiles' | 'accept' | 'allowMultipleFiles'>
> = {
  maxFiles: 10,
  accept: 'image/*,.pdf,.doc,.docx',
  allowMultipleFiles: true
};

/**
 * Returns the effective file upload config: defaults merged with user overrides.
 * Treats undefined, null, or non-object as "use defaults" (same as {}).
 * Caller should only call this when file upload is enabled (e.g. showUpload is true).
 */
export function getFileUploadConfig(
  userConfig?: FileUploadConfig | null
): FileUploadConfig & {
  maxFiles: number;
  accept: string;
  allowMultipleFiles: boolean;
} {
  const safe =
    userConfig != null &&
    typeof userConfig === 'object' &&
    !Array.isArray(userConfig)
      ? userConfig
      : {};
  return {
    ...DEFAULT_FILE_UPLOAD_CONFIG,
    ...safe,
    maxFiles:
      (safe as FileUploadConfig).maxFiles ??
      DEFAULT_FILE_UPLOAD_CONFIG.maxFiles,
    accept:
      (safe as FileUploadConfig).accept ?? DEFAULT_FILE_UPLOAD_CONFIG.accept,
    allowMultipleFiles:
      (safe as FileUploadConfig).allowMultipleFiles ??
      DEFAULT_FILE_UPLOAD_CONFIG.allowMultipleFiles
  };
}
